import { c as _c } from "react/compiler-runtime";
import { Button } from "@anima/ui/components/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@anima/ui/components/dropdown-menu";
import { Skeleton } from "@anima/ui/components/skeleton";
import Link from "next/link";
import type { Route } from "next";
import { Settings } from "lucide-react";
import { useRouter } from "@anima/ui/hooks/use-router";
import { authClient } from "@/lib/auth-client";
export default function UserMenu() {
  const $ = _c(24);
  const router = useRouter();
  const {
    data: session,
    isPending
  } = authClient.useSession();
  if (isPending) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Skeleton className="h-7 w-24" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (!session) {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Link href="/sign-in"><Button variant="outline">Sign In</Button></Link>;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button variant="outline" />;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== session.user.name) {
    t1 = <DropdownMenuTrigger render={t0}>{session.user.name}</DropdownMenuTrigger>;
    $[3] = session.user.name;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DropdownMenuLabel>My Account</DropdownMenuLabel>;
    t3 = <DropdownMenuSeparator />;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== router) {
    t4 = () => router.push("/settings/hotkeys" as Route);
    $[7] = router;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Settings className="mr-2 h-4 w-4" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <DropdownMenuItem onClick={t4}>{t5}Settings</DropdownMenuItem>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== session.user.email) {
    t7 = <DropdownMenuItem>{session.user.email}</DropdownMenuItem>;
    $[12] = session.user.email;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <DropdownMenuSeparator />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== router) {
    t9 = <DropdownMenuItem variant="destructive" onClick={() => {
      authClient.signOut({
        fetchOptions: {
          onSuccess: () => {
            router.push("/");
          }
        }
      });
    }}>Sign Out</DropdownMenuItem>;
    $[15] = router;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t9) {
    t10 = <DropdownMenuContent className="bg-card"><DropdownMenuGroup>{t2}{t3}{t6}{t7}{t8}{t9}</DropdownMenuGroup></DropdownMenuContent>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t1 || $[22] !== t10) {
    t11 = <DropdownMenu>{t1}{t10}</DropdownMenu>;
    $[21] = t1;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}